exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".estimate-cost-row-popup {}\r\n\r\n.estimate-cost-row-popup table th {\r\n    text-align: left;\r\n    padding: 4px 10px 4px 0px;\r\n}\r\n\r\n.estimate-cost-row-popup table td {\r\n    padding: 2px 20px 2px 0px;\r\n}\r\n\r\n.estimate-cost-row-popup .costs{\r\n    padding-top: 5px\r\n}\r\n\r\n.calculator-popup {\r\n    z-index: 10000 !important;\r\n}\r\n\r\n.estimate-cost-row-popup table.header {\r\n    width: 100%;\r\n}\r\n\r\n.estimate-cost-row-popup table.base td {\r\n    width: 150px;\r\n}\r\n\r\n.estimate-cost-row-popup .price-label {\r\n    border:0;\r\n}\r\n\r\n.estimate-cost-row-popup .dx-texteditor .dx-texteditor-input {\r\n    height: 28px;\r\n    min-height: 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/estimate-cost-row-popup/estimate-cost-row-popup.css
// module id = 69
// module chunks = 53